import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getAnswerShortQuestion = (params) => {
	var url = ApiRouters.ANSWERSHORTQUESTION;
	return api.get(url, { params });
};

export const getAnswerShortQuestionDetail = (id, params) => {
	var url = `${ApiRouters.ANSWERSHORTQUESTION}/${id}`;
	return api.get(url, { params });
};

export const createQuesAnswerShortQuestion = (body) => {
	var url = ApiRouters.ANSWERSHORTQUESTION;
	return api.post(url, body);
};

export const updateAnswerShortQuestionDetail = (body) => {
	var url = `${ApiRouters.ANSWERSHORTQUESTION}/${body.id}`;
	return api.put(url, body);
};

export const deleteAnswerShortQuestion = (id) => {
	var url = `${ApiRouters.ANSWERSHORTQUESTION}/${id}`;
	return api.delete(url);
};
